import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'projects/bis-shared/src/lib/material/material.module';
import { BadgeComponent } from './badge.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    BadgeComponent,
  ],
  exports: [
    BadgeComponent,
  ],
  providers: [],
})
export class BadgesModule { }
